import { render, staticRenderFns } from "./ShoppingCartIcon.vue?vue&type=template&id=2a4f0b1a&scoped=true&"
import script from "./ShoppingCartIcon.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartIcon.vue?vue&type=style&index=0&id=2a4f0b1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f0b1a",
  null
  
)

export default component.exports